'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var arrays = require('./arrays.js');
var magicSdk = require('@gig/magic-sdk');

var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const PHONE_SEPARATOR = " ";
function getPhoneValueAfterCountryChange(phoneTypeStateValue, countryCode) {
  return __async(this, null, function* () {
    const countries = yield magicSdk.magic.invokeCached(60, magicSdk.magic.methods.users, "getCountries")();
    const country = countries.countries.find(({ code }) => code === countryCode);
    let prevValue = "";
    let phoneValue = "";
    const splitStateValue = phoneTypeStateValue.split(PHONE_SEPARATOR);
    if (splitStateValue.length === 2) {
      prevValue = splitStateValue[1];
    }
    if (prevValue !== "" && country && country.phonePrefix) {
      phoneValue = `${country.phonePrefix} ${prevValue}`;
      return phoneValue;
    } else if (country && country.phonePrefix) {
      phoneValue = country.phonePrefix;
      return phoneValue;
    }
    return phoneValue;
  });
}
function getPreloadedPrefix() {
  return __async(this, null, function* () {
    const countries = yield magicSdk.magic.invokeCached(60, magicSdk.magic.methods.users, "getCountries")();
    const prefixes = getPrefixList(countries.countries).join(",");
    return {
      prefixes
    };
  });
}
function getPrefixList(countries) {
  const prefixes = countries.map(({ phonePrefix }) => phonePrefix).filter((prefix) => !!prefix);
  prefixes.sort();
  return arrays.uniqueValues(prefixes);
}
function convertPhoneValue(value) {
  return value ? value.split(PHONE_SEPARATOR) : ["", ""];
}

exports.PHONE_SEPARATOR = PHONE_SEPARATOR;
exports.convertPhoneValue = convertPhoneValue;
exports.getPhoneValueAfterCountryChange = getPhoneValueAfterCountryChange;
exports.getPrefixList = getPrefixList;
exports.getPreloadedPrefix = getPreloadedPrefix;
